import React from "react";
import Select from "react-select";
import InputRequire from "views/components/InputRequire";

export const FormSelect = ({
  label,
  value,
  onChange,
  options,
  placeholder,
  isLoading,
  isMulti = false,
  isClearable = false,
  isDisabled = false,
  required = false,
  errors = [],
  t,
}) => {
  
  return (
    <div
      className={errors.length ? "form-group row validated" : "form-group row"}
    >
      {label && (
        <label className="col-xl-3 col-lg-3 col-form-label">
          {t(label)} {required && <InputRequire />}
        </label>
      )}
      <div className={`col-lg-9 ${!label ? "col-xl-12" : "col-xl-6"}`}>
        <Select
          isClearable={isClearable}
          isMulti={isMulti}
          isDisabled={isDisabled}
          placeholder={t(placeholder)}
          value={value}
          onChange={onChange}
          options={options}
          isLoading={isLoading}
        />
        {errors.length > 0 &&
          errors.map((error, index) => (
            <div key={index} className="invalid-feedback">
              {error}
            </div>
          ))}
      </div>
    </div>
  );
};
